export default __webpack_public_path__ + "static/media/triangleExclamation.be89e931.svg";